var map = {
	"./1.jpg": 1986,
	"./29213190-businessman-silhouette-avatar-profile-picture.webp": 4612,
	"./29213218-female-avatar-silhouette-profile-pictures.webp": 2307,
	"./29213222-male-silhouette-avatar-profile-picture.webp": 9699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6301;